import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function StravaCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("Connecting your Strava account…");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const error = params.get("error");
    const code = params.get("code");
    const state = params.get("state");

    if (error) {
      setStatus("Strava authorisation was cancelled. Redirecting…");
      setTimeout(() => navigate("/dashboard"), 1800);
      return;
    }
    if (!code) {
      setStatus("Missing code from Strava. Redirecting…");
      setTimeout(() => navigate("/dashboard"), 1800);
      return;
    }

    api.post("/strava/callback", { code, state })
      .then(async () => {
        setStatus("Connected! Pulling your recent activities in the background…");
        await refresh();
        setTimeout(() => navigate("/activity"), 1500);
      })
      .catch(() => {
        setStatus("Could not connect Strava. Please try again from the dashboard.");
        setTimeout(() => navigate("/dashboard"), 2500);
      });
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="hairline bg-zinc-900 p-10 max-w-md text-center">
        <p className="font-mono text-[11px] tracking-[0.3em] text-orange-500 uppercase">STRAVA</p>
        <h1 className="font-display text-3xl text-white mt-3">{status}</h1>
        <p className="font-mono text-[10px] text-zinc-500 tracking-widest uppercase mt-4">
          Please wait…
        </p>
      </div>
    </div>
  );
}
